import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle, ChefHat, Clock, Mail, ArrowRight } from "lucide-react";

export default function OwnerSuccess() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="max-w-lg w-full">
        <Card>
          <CardContent className="p-8 text-center">
            <div className="w-16 h-16 rounded-full bg-green-500/10 flex items-center justify-center mx-auto mb-6">
              <CheckCircle className="w-8 h-8 text-green-500" />
            </div>
            
            <h1 className="text-2xl font-bold mb-2">Application Submitted!</h1>
            <p className="text-muted-foreground mb-6">
              Thank you for your interest in joining Eatzy Kudoz. We've received your application and our team is reviewing it.
            </p>

            <div className="space-y-4 text-left bg-muted/50 rounded-lg p-4 mb-6">
              <div className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-primary mt-0.5" />
                <div>
                  <p className="font-medium">Review Time</p>
                  <p className="text-sm text-muted-foreground">
                    We typically review applications within 24-48 hours
                  </p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-primary mt-0.5" />
                <div>
                  <p className="font-medium">What's Next</p>
                  <p className="text-sm text-muted-foreground">
                    You'll receive an email notification once your application is approved
                  </p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <ChefHat className="w-5 h-5 text-primary mt-0.5" />
                <div>
                  <p className="font-medium">Get Ready</p>
                  <p className="text-sm text-muted-foreground">
                    After approval, you can start receiving orders through the Eatzy app
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-3">
              <Link href="/">
                <Button className="w-full gap-2">
                  Go to Home
                  <ArrowRight className="w-4 h-4" />
                </Button>
              </Link>
              <Link href="/owner">
                <Button variant="outline" className="w-full">
                  Back to Owner Portal
                </Button>
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
